module.exports = __webpack_public_path__ + "img/sr-logo-gray.84026f9b.png";